import React from 'react';
import GlobalMenu from '@/components/global/menu/GlobalMenu';
import BonusHistory from '@/components/contents/history/bonus/BonusHistory';

export default function BonusHistoryPage() {
    return (
        <div id="wrap" className="main sub_page">
            <div className="history">
                <div className="inner">
                    <GlobalMenu />
                </div>
                <BonusHistory />
            </div>
        </div>
    );
}
